import { UNREAD_UPDATE_COUNTS } from '@/store/actions/unread/action-typs';

const initialState = {
  inquiry: 0,
  openChat: 0
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UNREAD_UPDATE_COUNTS: {
      const inquiry = Number(payload?.inquiry);
      const openChat = Number(payload?.openChat);
      return {
        inquiry: Number.isFinite(inquiry) && inquiry >= 0 ? inquiry : 0,
        openChat: Number.isFinite(openChat) && openChat >= 0 ? openChat : 0
      };
    }
    default:
      return state;
  }
};

export default reducer;
